const getFileSource = (image: File | Blob) => {
	return new Promise<string | ArrayBuffer | null>((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = event => resolve(event.target?.result || null);
		reader.onerror = reject;
		reader.readAsDataURL(image);
	});
}

export default getFileSource;